import React from 'react';
import { MailIcon } from 'lucide-react';
import { Section } from './Section';
import { WhatsAppButton } from './WhatsAppButton';
import { CONTACT_EMAIL, WHATSAPP_DISPLAY } from '../data/config';
export function Contact() {
  return <Section className="bg-cream-50" data-id="element-78" data-mp="3173hx8kzhggq">
      <div className="rounded-[2rem] border border-ink-950/10 bg-white p-7 text-center sm:p-10" data-id="element-79" data-mp="2w7gt01vsmbs3">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent-deep" data-id="element-80" data-mp="3sxq40je6d9x9">Contacto</p>
        <h2 className="mt-4 text-2xl font-extrabold leading-tight tracking-tight text-ink-950 sm:text-3xl" data-id="element-81" data-mp="3szkhjcn49zrb">
          ¿Tenés preguntas, dudas o consultas del contenido?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ink-800/80 sm:text-base" data-id="element-82" data-mp="3k3bfdq7r8n1h">
          Mandame un mensaje y te respondemos al toque: acceso, contenido, pago y devoluciones.
        </p>
        <div className="mt-7" data-id="element-83" data-mp="gi5oxeo2se14">
          <WhatsAppButton label={`Mandame un mensaje: ${WHATSAPP_DISPLAY}`} data-id="element-84" data-mp="bp2tt23ngwit" />
        </div>
        <blockquote className="mx-auto mt-8 max-w-lg border-t border-ink-950/10 pt-7 text-base font-semibold italic leading-relaxed text-ink-950 sm:text-lg" data-id="element-85" data-mp="3jvusse8xzfus">
          “No hay preguntas tontas; tonto es quedarse con la duda.”
        </blockquote>
        <p className="mt-7 flex flex-wrap items-center justify-center gap-2 text-xs text-ink-950/55" data-id="element-86" data-mp="3b2rhoclrrf3b">
          <MailIcon className="h-4 w-4 text-ink-950/40" aria-hidden="true" data-id="element-87" data-mp="3f3betg6ceipg" />
          También podés escribirnos a
          <a href={`mailto:${CONTACT_EMAIL}`} className="font-semibold text-ink-950/70 underline decoration-ink-950/20 underline-offset-4 transition-colors hover:text-ink-950" data-id="element-88" data-mp="31769txu0rkln">
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </Section>;
}